
import { Notice } from "./notice";
import { UnreadMessage } from "./unread-message";

export class NoticeWithUnreadMessageDto extends Notice {
  public unreadMessage: UnreadMessage;
}
